module.exports = __webpack_public_path__ + "img/WM.f7b62408.png";